import React from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useState, useEffect, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MaterialReactTable from "material-react-table";
import {
  faArrowLeft,
  faEye,
  faImage,
} from "../../../node_modules/@fortawesome/free-solid-svg-icons/index";
import { useNavigate, useLocation } from "react-router-dom";
import L from "leaflet";
import { MapContainer, Polygon, TileLayer, WMSTileLayer, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
// import "../../assets/styles/FarmerDetailView.css";
import AdminHeaderNew from "../NewAdminPanel/Common/AdminHeader";
import AdminSideBarNew from "../NewAdminPanel/Common/AdminSideBar";
import AdminFooterNew from "../NewAdminPanel/Common/AdminFooter";
import NMEOOPDeatils from "../NewAdminPanel/NMEOOPDeatilPage";
import NMEOOSDeatils from "../NewAdminPanel/NMEOOSDeatilPage";
import PDMCDeatils from "../NewAdminPanel/PDMCDeatilPage";
import AgroDeatils from "../NewAdminPanel/AgroDeatilPage";
import RKVYDetails from "../NewAdminPanel/RKVYFarmerList";
import MOVCDDetails from "../NewAdminPanel/MOVCDfarmerList";
import PKVYFarmerList from "../NewAdminPanel/PKVYFarmerList";


const containerStyle = {
  width: "100%",
  height: "50vh",
};

const center = {
  lat: 28.641832439372656,
  lng: 77.22480777651072,
};
const bhuvanLayerUrl = 'https://bhuvan-ras1.nrsc.gov.in/tilecache/tilecache.py';
const FitBounds = ({ bounds }) => {
  const map = useMap();

  useEffect(() => {
    if (bounds && bounds.isValid()) {
      map.fitBounds(bounds, { padding: [20, 20] });
    }
  }, [bounds, map]);

  return null;
};

const parseCoordinatePair = (pair) => {
  if (!Array.isArray(pair) || pair.length < 2) {
    return null;
  }

  const first = Number(pair[0]);
  const second = Number(pair[1]);

  if (Number.isNaN(first) || Number.isNaN(second)) {
    return null;
  }

  if (Math.abs(first) > 90 && Math.abs(second) <= 90) {
    return [second, first];
  }

  return [first, second];
};

const normalizePolygonShape = (rawPolygonShape) => {
  if (!rawPolygonShape) {
    return [];
  }

  let parsed = rawPolygonShape;
  if (typeof rawPolygonShape === "string") {
    try {
      parsed = JSON.parse(rawPolygonShape);
    } catch (_) {
      return [];
    }
  }

  if (!Array.isArray(parsed) || parsed.length === 0) {
    return [];
  }

  if (Array.isArray(parsed[0])) {
    return parsed.map(parseCoordinatePair).filter(Boolean);
  }

  return parsed
    .map((point) => {
      if (!point || typeof point !== "object") {
        return null;
      }

      const latValue = Number(
        point.lat ?? point.latitude ?? point.Latitude ?? point.y
      );
      const lngValue = Number(
        point.lng ?? point.lon ?? point.longitude ?? point.Longitude ?? point.x
      );

      if (Number.isNaN(latValue) || Number.isNaN(lngValue)) {
        return null;
      }

      return [latValue, lngValue];
    })
    .filter(Boolean);
};

const getDemonstrationPolygonPaths = (data) => {
  if (!data) {
    return [];
  }

  const geoPlotting =
    data?.inputDetails?.[0]?.geoPlotting ?? data?.geoPlotting;
  if (!geoPlotting) {
    return [];
  }

  const normalized = normalizePolygonShape(geoPlotting);
  return normalized.length > 0 ? [normalized] : [];
};

function FarmerDetailView() {
  const navigate = useNavigate();
  let { state } = useLocation();
  const [formsData, setFormsData] = useState([]);
  const [cropSurveyData, setCropSurveyData] = useState(null);
  const [imageData, setImageData] = useState([]);
  const [componentName, setComponentName] = useState("");

  const [cropName, setCropName] = useState([]);
  const [cropGroupName, setCropGroupName] = useState([]);
  const [cropYield, setCropYield] = useState([]);

  const [activeImage, setActiveImage] = useState();

  const [coconutName, setCoconutName] = useState("")
  const [dasdName, setDasdName] = useState("")

  let imageSrc = [];

  useEffect(() => {
  console.log("state", state);
  if (state && state.farmerCode) {
    console.log("stateFarmer", state);
    // Set a default scheme code for MT module
    if (!sessionStorage.getItem("schemeCodeModel")) {
      sessionStorage.setItem("schemeCodeModel", "1");
    }
    const schemeCodeModel = sessionStorage.getItem("schemeCodeModel");

    // Fetch detailed data based on schemeCodeModel
    // if (schemeCodeModel === "1") {
    //   fetchDetailedData(state.farmerCode.farmerCode);
    // }
     if (schemeCodeModel === "9") {
      fetchDetailedDataMovcd(state.farmerCode.farmerCode);
    } else if (schemeCodeModel === "14") {
      fetchDetailedDataNMEOOP(state.farmerCode.farmerCode);
    } else if (schemeCodeModel === "17") {
      fetchDetailedDataDCCD(state.farmerCode.farmerCode);
    } else if (schemeCodeModel === "5") {
      // NMEO-OS: data already present in navigation state, set it directly.
      setCropSurveyData(state.farmerCode);
    }

    // Set component name based on schemeCodeModel and orgTypeCode
    if (schemeCodeModel === "7") {
      if (state.farmerCode.orgTypeCode === 1) {
        setComponentName("Honey Processing Unit");
      } else if (state.farmerCode.orgTypeCode === 2) {
        setComponentName("Honey Testing Unit");
      } else if (state.farmerCode.orgTypeCode === 3) {
        setComponentName("Honey CHC");
      } else {
        setComponentName("Beeflora Plantation");
      }
    } else if (schemeCodeModel === "3") {
      if (state.farmerCode.orgTypeCode === 1) {
        setComponentName("Nursery");
      } else if (state.farmerCode.orgTypeCode === 2) {
        setComponentName("Tissue Total Count");
      }
    }

    // Set coconut name if schemeCodeModel is "10"
    if (schemeCodeModel === "10") {
      if (state.farmerCode.componentId === 12) {
        setCoconutName("Nursery");
      } else if (state.farmerCode.componentId === 13) {
        setCoconutName("Seed Garden");
      } else {
        setCoconutName("Unit");
      }
    }

    // Only set crop survey data if schemeCodeModel is not "1" and not "9"
    if (schemeCodeModel !== "1" && schemeCodeModel !== "9") {
      setCropSurveyData(state.farmerCode);
    }
  }
}, [state]);


  async function fetchDetailedData(value) {
    try {
      console.log("Fetching farmer data for farmerCode:", value);
      let result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsList`, {
        "schemeCode": "1",
        "orgTypeCode": 0,
        "SurveyUserCode": "0",
        "stateCode": "0",
        "districtCode": "0",
        "subDistrictCode": "0",
        "farmerCode": value
      })
      console.log("API Response:", result.data);
      
      if (result.data && result.data.dataContent && result.data.dataContent.length > 0) {
        state = result.data.dataContent[0]
        setCropSurveyData(result.data.dataContent[0])
        console.log("@@@", result.data.dataContent[0], cropSurveyData)
      } else {
        console.error("No data found in response");
        alert("No farmer details found for this record.");
      }
    } catch (error) {
      console.error("Error fetching farmer data:", error);
      alert("Failed to fetch farmer details. Please try again.");
    }
  }


  async function fetchDetailedDataMovcd(value) {
    try {
      console.log("Fetching MOVCD data for farmerCode:", value);
      let result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListNew`, {
        "schemeCode": "9",
        "orgTypeCode": 0,
        "SurveyUserCode": "0",
        "stateCode": "0",
        "districtCode": "0",
        "subDistrictCode": "0",
        "farmerCode": value
      })
      console.log("MOVCD API Response:", result.data);
      
      if (result.data && result.data.dataContent && result.data.dataContent.length > 0) {
        state = result.data.dataContent[0]
        setCropSurveyData(result.data.dataContent[0])
        console.log("@@@", result.data.dataContent[0], cropSurveyData)

    if (sessionStorage.getItem("schemeCodeModel") === "9") {
      console.log("multiCropGroupName", state.farmerCode.farmerCropDetailsExtsList);
      if (state.farmerCode.farmerCropDetailsExtsList.length !=0) {
       
        let cropGroup =
          state.farmerCode.farmerCropDetailsExtsList[0].multiCropGroupName.split(
            "||"
          );
        setCropGroupName(cropGroup);


        let cropName =
          state.farmerCode.farmerCropDetailsExtsList[0].multiCropName.split(
            "||"
          );
        setCropName(cropName);

        let cropYield =
          state.farmerCode.farmerCropDetailsExtsList[0].multiYieldName.split(
            "||"
          );
        setCropYield(cropYield);
      }
    }
      } else {
        console.error("No data found in MOVCD response");
        alert("No farmer details found for this record.");
      }
    } catch (error) {
      console.error("Error fetching MOVCD data:", error);
      alert("Failed to fetch farmer details. Please try again.");
    }
  }

   // NMEO - OP
   
  async function fetchDetailedDataNMEOOP(value) {
    try {
      console.log("Fetching NMEO-OP data for farmerCode:", value);
      let result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/NMEO_OP/getNMEOFarmerDetailsList`, {
        "schemeCode": "14",
        "orgTypeCode": 0,
        "SurveyUserCode": "0",
        "stateCode": "0",
        "districtCode": "0",
        "subDistrictCode": "0",
        "lngA_FarmerCode": value
      })
      console.log("NMEO-OP API Response:", result.data);
      
      if (result.data && result.data.dataContent && result.data.dataContent.length > 0) {
        state = result.data.dataContent[0]    
        setCropSurveyData(result.data.dataContent[0])
        console.log("NMEO-OP Data set successfully:", result.data.dataContent[0], cropSurveyData)
      } else {
        console.error("No data found in NMEO-OP response");
        alert("No farmer details found for this record.");
      }
    } catch (error) {
      console.error("Error fetching NMEO-OP data:", error);
      alert("Failed to fetch farmer details. Please try again.");
    }
  }
//DCCD
async function fetchDetailedDataDCCD(value) {
    try {
      console.log("Fetching DCCD data for farmerCode:", value);
      let result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MIDH/MIDHFarmerDetails/GetDccdFarmerDetailsAsync`, {
        "schemeCode": "17",
        "orgTypeCode": 0,
        "SurveyUserCode": "0",
        "stateCode": "0",
        "districtCode": "0",
        "subDistrictCode": "0",
        "farmerCode": value
      })
      console.log("DCCD API Response:", result.data);
      
      if (result.data && result.data.dataContent && result.data.dataContent.length > 0) {
        const farmerData = result.data.dataContent[0];
        state = farmerData;
        setCropSurveyData(farmerData);
        console.log("DCCD Data set successfully:", farmerData);
      } else {
        console.error("No data found in DCCD response");
        alert("No farmer details found for this record.");
      }
    } catch (error) {
      console.error("Error fetching DCCD data:", error);
      alert("Failed to fetch farmer details. Please try again.");
    }
  }
const WMSTileLayer = ({ url, layers, ...props }) => {
  const map = useMap();
  
  useEffect(() => {
    const wmsLayer = L.tileLayer.wms(url, {
      layers: layers,
      format: 'image/png',
      transparent: true,
      attribution: 'Bhuvan NRSC',
      maxZoom: 18,
      version: '1.1.1',
      srs: 'EPSG:3857',
      Maxresolution: 156543.033928,
      styles: '',
      ...props
    }).addTo(map);

    return () => {
      map.removeLayer(wmsLayer);
    };
  }, [map, url, layers, props]);

  return null;
};

  // useEffect(() => {
  //     console.log("sate", state);
  //     var myHeaders = new Headers();
  //     myHeaders.append("Content-Type", "application/json");

  //     var raw = JSON.stringify({
  //         "farmerCode": String(state.farmerCode.farmerCode)
  //     });

  //     var requestOptions = {
  //         method: 'POST',
  //         headers: myHeaders,
  //         body: raw,
  //         redirect: 'follow'
  //     };

  //     fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/PDMC/farmerSurveyPolygon/getFarmersSurveyList`, requestOptions)
  //         .then(response => response.json())
  //         .then(result => {
  //             setFormsData(result.dataContent)
  //         })
  //         .catch(error => console.log('error', error));

  // }, [])

  // useEffect(() => {

  //     axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/trancropsurvey/getCropSurveyByCropSurveyCode`, {
  //         "CropSurveyCode": String(state.cropSurveyCode)
  //     })
  //     .then((response) => {
  //         setCropSurveyData(response.data.dataContent);
  //     });

  // }, [])
  const polygonPaths = useMemo(() => {
    const polygonsFromState = state?.farmerCode?.farmerCropSurveyPolygonList;
    const polygonsFromSurvey = cropSurveyData?.farmerCropSurveyPolygonList;
    const polygonSource =
      Array.isArray(polygonsFromSurvey) && polygonsFromSurvey.length > 0
        ? polygonsFromSurvey
        : polygonsFromState;

    const polygonShapes =
      Array.isArray(polygonSource) && polygonSource.length > 0
        ? polygonSource
            .map((item) => normalizePolygonShape(item?.polygonShape))
            .filter((shape) => shape.length > 0)
        : [];

    if (polygonShapes.length > 0) {
      return polygonShapes;
    }

    const demonstrationShape =
      getDemonstrationPolygonPaths(cropSurveyData) ||
      getDemonstrationPolygonPaths(state?.farmerCode);

    return demonstrationShape;
  }, [cropSurveyData, state]);

  const mapBounds = useMemo(() => {
    if (polygonPaths.length === 0) {
      return null;
    }

    const allPoints = polygonPaths.flat();
    if (allPoints.length === 0) {
      return null;
    }

    return L.latLngBounds(allPoints);
  }, [polygonPaths]);

  const mapCenterLatLng = useMemo(() => {
    if (mapBounds && mapBounds.isValid()) {
      const mapCenterValue = mapBounds.getCenter();
      return [mapCenterValue.lat, mapCenterValue.lng];
    }

    return [center.lat, center.lng];
  }, [mapBounds]);


  const columns = useMemo(
    () => [
      {
        header: "S.No",
        Cell: (cell) => Number(cell.row.id) + 1,
      },

      {
        accessorKey: "farmerName",
        header: "Farmer Name",
      },
      {
        accessorKey:"schemeName",
        header:"Scheme Name",
      },
      {
        accessorKey: "cropStageName",
        header: "Crop Stage",
      },

      {
        accessorKey: "cropRatio",
        header: "Ratio(%)",
      },

      {
        accessorKey: "dateofSowing",
        header: "Date of Sowing ",
      },

      {
        accessorKey: "croppingPattern",
        header: "Cropping Pattern",
      },
      // {
      //     accessor: '',
      //     header: 'View Details',
      //     Cell: cell => <div data-bs-toggle="modal" data-bs-target="#staticBackdrop"> <i><FontAwesomeIcon className="hover" icon={faImage} onClick={() => handleImageView(cell.row.original)} /></i></div>
      // },
    ],
    []
  );

  function removed() {
    var mpopup = document.getElementById("mpopupBox");
    mpopup.style.display = "none";
  }

  function handleActiveClick(value) {
    setActiveImage(value);
    console.log("value@@@@@", value);
    let innerhtml = ` <img src=${process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEV_MODE +
        "/api/common/GetAttachbyURL?imageURL=" +
        cropSurveyData.farmerCropSurveyImageList[value].attPath
        : process.env.REACT_APP_PRO_MODE +
        "/api/common/GetAttachbyURL?imageURL=" +
        cropSurveyData.farmerCropSurveyImageList[value].attPath
      } alt="farmer Image" className="img-fluid w-100 h-50" />`;
    document.getElementById("modalBody").innerHTML = innerhtml;
  }

  return (
    <>
      <AdminHeaderNew />
      <AdminSideBarNew />
      
      {sessionStorage.getItem("schemeCodeModel") === "14" && <NMEOOPDeatils farmerCode={state?.farmerCode} />}
      {sessionStorage.getItem("schemeCodeModel") === "5" && <NMEOOSDeatils farmerCode={state?.farmerCode} />}
      {sessionStorage.getItem("schemeCodeModel") === "15" && <RKVYDetails projectCode={state?.projectCode} />}
      {sessionStorage.getItem("schemeCodeModel") === "1" && <PDMCDeatils farmerCode={state?.farmerCode} />}
      {sessionStorage.getItem("schemeCodeModel") === "3" && <AgroDeatils />}
      {sessionStorage.getItem("schemeCodeModel") === "9" && <MOVCDDetails />}
      {sessionStorage.getItem("schemeCodeModel") === "22" && <PKVYFarmerList/>}
      {sessionStorage.getItem("schemeCodeModel") !== "3" && 
       sessionStorage.getItem("schemeCodeModel") !== "9" && 
       sessionStorage.getItem("schemeCodeModel") !== "5" && 
       sessionStorage.getItem("schemeCodeModel") !== "14" && 
       sessionStorage.getItem("schemeCodeModel") !== "15" &&
       sessionStorage.getItem("schemeCodeModel") !== "22" && 
       sessionStorage.getItem("schemeCodeModel") !== "1" && (
        <main id="main" className="main">
          <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
            <nav>
              <h1>Farmer Details View</h1>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">Farmer</li>
                <li className="breadcrumb-item active">Farmer Details View</li>
              </ol>
            </nav>
            <button
              type="button"
              className="btn btn-success"
              onClick={() => navigate(-1)}
            >  
              <i>
                <FontAwesomeIcon icon={faArrowLeft} />
              </i>{" "}
              Back
            </button>
          </div>
          <section className="section">
            <div className="row">
              <div className="col-lg-12 dashboard">
                <div className="card">
                  {/* </div>
                        </div>
                        <div className="col-lg-12 dashboard">
                            <div className="card"> */}
                  {cropSurveyData && (
                    <div className="card-body p-5 pt-2">
                      <div className="row cropview">
                        <h5 className="formgrouping">Polygon Details</h5>
                        <MapContainer
                        center={mapCenterLatLng}
                         zoom={14}
                       maxZoom={18}  
                  style={containerStyle}
                 scrollWheelZoom
                  zoomControl={true}
                        >
                       <WMSTileLayer
  url={bhuvanLayerUrl}
  layers="bhuvan_wbase_ind"
/>
                          {polygonPaths.map((path, index) => (
                            <Polygon
                              key={`farmer-polygon-${index}`}
                              positions={path}
                              pathOptions={{
                                color: "#FF0000",
                                fillColor: "#FF0000",
                                fillOpacity: 0.1,
                                weight: 2,
                              }}
                            />
                          ))}
                          {mapBounds ? <FitBounds bounds={mapBounds} /> : null}
                        </MapContainer>
                      </div>
                      <h5 className="formgrouping">Survey Details</h5>
                      <div className="row surveydetailsbg">
                        <div className="col-md-3">
                          <h6>Survey No.</h6>
                          <p>{cropSurveyData?.surveyNo || "N/A"}</p>
                        </div>

                        {
                          sessionStorage.getItem("schemeCodeModel") === "7" ? (
                          <div className="col-md-3">
                            <h6>Beneficiary Name</h6>
                            <p>{cropSurveyData?.beneficiaryName || "N/A"}</p>
                          </div>
                        ) : (
                          <div className="col-md-3">
                            <h6>Surveyor Name</h6>
                            <p>
                              {
                                cropSurveyData.farmerCropSurveyPolygonList && 
                                cropSurveyData.farmerCropSurveyPolygonList[0] 
                                  ? cropSurveyData.farmerCropSurveyPolygonList[0].userName 
                                  : ""
                              }
                            </p>
                          </div>
                        )}
                        <div className="col-md-3">
                          <h6>Created Date</h6>
                          <p>
                            {
                              cropSurveyData.farmerCropSurveyPolygonList && 
                              cropSurveyData.farmerCropSurveyPolygonList[0] &&
                              cropSurveyData.farmerCropSurveyPolygonList[0].createdOnByUC
                                ? cropSurveyData.farmerCropSurveyPolygonList[0].createdOnByUC.split("T")[0] 
                                : ""
                            }
                          </p>
                        </div>
                        {
                          sessionStorage.getItem("schemeCodeModel") === "7" ||
                          sessionStorage.getItem("schemeCodeModel") === "8" ? (
                          ""
                        ) : (
                          <div className="col-md-3">
                            <h6>{sessionStorage.getItem("schemeCodeModel") === "10" && cropSurveyData.componentId === 14 ? "Building area (in sq. Feet)" : "Land Area (in Ha)"}</h6>
                            <p>
                              {sessionStorage.getItem("schemeCodeModel") === "10"
                                ? cropSurveyData.area
                                : cropSurveyData.landArea}
                            </p>
                          </div>
                        )}

                        {sessionStorage.getItem("schemeCodeModel") === "10" ? (
                          <div className="col-md-3">
                            <h6>Land Type</h6>
                            <p>
                              {cropSurveyData.landType}
                            </p>
                          </div>
                        ) : ""}

                        {cropSurveyData.totalArea ? (
                          <div className="col-md-3">
                            <h6>Total Area Under OF (in Ha)</h6>
                            <p>{cropSurveyData.totalArea}</p>
                          </div>
                        ) : (
                          ""
                        )}

                        {sessionStorage.getItem("schemeCodeModel") === "10" && cropSurveyData.componentId === 14 ? (
                          <div className="col-md-3">
                            <h6>Capacity ({cropSurveyData.capacityUnitName})</h6>
                            <p>
                              {cropSurveyData.capacityValue}
                            </p>
                          </div>
                        ) : ""}



                        {sessionStorage.getItem("schemeCodeModel") === "8" ? (
                          <div className="col-md-3">
                            <h6>Farm Id</h6>
                            <p>{cropSurveyData.farmID}</p>
                          </div>
                        ) : (
                          ""
                        )}
                        {cropSurveyData.finYear ? (
                          <div className="col-md-3">
                            <h6>Financial Year</h6>
                            <p>{cropSurveyData.finYear}</p>
                          </div>
                        ) : (
                          ""
                        )}
                        {sessionStorage.getItem("schemeCodeModel") === "91" ? (
                          <div className="col-md-3">
                            <h6>Financial Year</h6>
                            <p>
                              {
                                cropSurveyData.farmerCropDetailsExtsList && 
                                cropSurveyData.farmerCropDetailsExtsList[0]
                                  ? cropSurveyData.farmerCropDetailsExtsList[0].finYear
                                  : ""
                              }
                            </p>
                          </div>
                        ) : (
                          ""
                        )}
                        {cropSurveyData.categoryName ? (
                          <div className="col-md-3">
                            <h6>Category </h6>
                            <p>{cropSurveyData.categoryName}</p>
                          </div>
                        ) : (
                          ""
                        )}
                        {cropSurveyData.typeName ? (
                          <div className="col-md-3">
                            <h6>Type </h6>
                            <p>{cropSurveyData.typeName}</p>
                          </div>
                        ) : (
                          ""
                        )}

                        {cropSurveyData.cropLifeCycleName ? (
                          <div className="col-md-3">
                            <h6>Crop Life Cycle </h6>
                            <p>{cropSurveyData.cropLifeCycleName}</p>
                          </div>
                        ) : (
                          ""
                        )}
                        {cropSurveyData.gardenAgeName ? (
                          <div className="col-md-3">
                            <h6>Garden Age </h6>
                            <p>{cropSurveyData.gardenAgeName}</p>
                          </div>
                        ) : (
                          ""
                        )}
                        {cropSurveyData.farmerCropDetailsExtsList && cropSurveyData.farmerCropDetailsExtsList[0] ? (
                          <div className="col-md-3">
                            <h6>Season </h6>
                            <p>
                              {
                                cropSurveyData.farmerCropDetailsExtsList[0].seasonName
                              }
                            </p>
                          </div>
                        ) : (
                          ""
                        )}
                        {sessionStorage.getItem("schemeCodeModel") === "8" || sessionStorage.getItem("schemeCodeModel") === "10" || sessionStorage.getItem("schemeCodeModel") === "11" ? (
                          <>
                            <div className="col-md-3">
                              <h6>Component Name</h6>
                              <p>{cropSurveyData.componentName}</p>
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                        <div className="col-md-3">
                          <h6>Scheme Name</h6>
                          <p>
                            {cropSurveyData?.schemeName ||
                              state?.farmerCode?.schemeName ||
                              sessionStorage.getItem("currentSchemeName") ||
                              "N/A"}
                          </p>
                        </div>

                                              {sessionStorage.getItem("schemeCodeModel") === "8"  ? (
                                                  <>
                                                      <div className="col-md-3">
                                                          <h6>Crop Category Name</h6>
                                                          <p>{cropSurveyData.CropCategoryName}</p>
                                                      </div>
                                                      <div className="col-md-3">
                                                          <h6>Crop Name</h6>
                                                          <p>{cropSurveyData.CropName}</p>
                                                      </div>
                                                      <div className="col-md-3">
                                                          <h6>Season Name</h6>
                                                          <p>{cropSurveyData.SeasonName}</p>
                                                      </div>
                                                  </>
                                              ) : (
                                                  ""
                                              )}

                        {sessionStorage.getItem("schemeCodeModel") === "91" ? (
                          <div className="col-md-3">
                            <h6>Does Farmers have smart phone ?</h6>
                            <p>
                              {cropSurveyData.smartPhone}
                            </p>
                          </div>
                        ) : ""}
                        {sessionStorage.getItem("schemeCodeModel") === "10" && cropSurveyData.componentId != 14 ? (
                          <div className="col-md-3">
                            <h6>No. of Seedlings</h6>
                            <p>
                              {cropSurveyData.seeding_No}
                            </p>
                          </div>
                        ) : ""}
                        {sessionStorage.getItem("schemeCodeModel") === "10" && cropSurveyData.componentId === 14 ? (
                          <div className="col-md-3">
                            <h6>Product Name</h6>
                            <p>
                              {cropSurveyData.productName}
                            </p>
                          </div>
                        ) : ""}

                        {sessionStorage.getItem("schemeCodeModel") === "7" ? (
                          <div className="col-md-3">
                            <h6>Component Name</h6>
                            <p>{componentName}</p>
                          </div>
                        ) : (
                          ""
                        )}
                        {sessionStorage.getItem("schemeCodeModel") != "32" ? (
                          <div className="col-md-3">
                            <h6>Component Name</h6>
                            <p>{componentName}</p>
                          </div>
                        ) : (
                          ""
                        )}
                        {sessionStorage.getItem("schemeCodeModel") != "11" ? (
                          ""
                        ) : (
                          <div className="col-md-3">
                            <h6>Project Id</h6>
                            <p>
                              {cropSurveyData.projectId}
                            </p>
                          </div>
                        )}
                        {sessionStorage.getItem("schemeCodeModel") != "11" ? (
                          ""
                        ) : (
                          <div className="col-md-3">
                            <h6>Institute Name</h6>
                            <p>
                              {cropSurveyData.instituteName}
                            </p>
                          </div>
                        )}
                        {sessionStorage.getItem("schemeCodeModel") != "11" ? (
                          ""
                        ) : (
                          <div className="col-md-3">
                            <h6>Center Name</h6>
                            <p>
                              {cropSurveyData.centerName}
                            </p>
                          </div>
                        )}
                        {sessionStorage.getItem("schemeCodeModel") != "11" ? (
                          ""
                        ) : (
                          <div className="col-md-3">
                            <h6>Address</h6>
                            <p>
                              {cropSurveyData.address}
                            </p>
                          </div>
                        )}
                        {sessionStorage.getItem("schemeCodeModel") != "11" ? (
                          ""
                        ) : (
                          <div className="col-md-3">
                            <h6>Scheme Data Type</h6>
                            <p>
                              {cropSurveyData.schemeDataTypeName}
                            </p>
                          </div>

                        )}

                        {cropSurveyData.farmerID ? (
                          <div className="col-md-3">
                            <h6>Farmer Id </h6>
                            <p>{cropSurveyData.gardenAgeName}</p>
                          </div>
                        ) : (
                          ""
                        )}

                        {sessionStorage.getItem("schemeCodeModel") != "11" ? (
                          ""
                        ) : (
                          <div className="col-md-3">
                            <h6>Farm Id</h6>
                            <p>
                              {cropSurveyData.farmID}
                            </p>
                          </div>

                        )}
                      </div>

                      <div className="row cropview">
                        <h5 className="formgrouping">Personal Details</h5>
                        <div className="row surveydetailsbg">
                        {sessionStorage.getItem("schemeCodeModel") === "10" ? (
                          


                          <div className="col-md-3">
                            <h6>{coconutName + " ID"}</h6>
                            <p>{cropSurveyData.projectCode}</p>
                          </div>
                        ) : ""}
                        {
                          sessionStorage.getItem("schemeCodeModel") === "7" ||
                          sessionStorage.getItem("schemeCodeModel") === "10" ? (
                          <div className="col-md-3">
                            <h6>{sessionStorage.getItem("schemeCodeModel") === "10" ? coconutName + " Name" : "Project Name"}</h6>
                            <p>{cropSurveyData.projectName}</p>
                          </div>
                        ) : (


                          <>


                            <div className="col-md-3">
                              <h6>Farmer Name</h6>
                              <p>{cropSurveyData.farmerName} 
                               </p>
                            </div>
                           
                            

                          </>
                        )}
                        {sessionStorage.getItem("schemeCodeModel") === "8" || sessionStorage.getItem("schemeCodeModel") === "11" ? (
                          <div className="col-md-3">
                            <h6>Father / Husband Name</h6>
                            <p>{cropSurveyData.fatherName}</p>
                          </div>
                        ) : (
                          ""
                        )}



                        <div className="col-md-3">
                          <h6>Aadhaar No.</h6>
                          <p>
                            {sessionStorage.getItem("schemeCodeModel") === "10"
                              ? cropSurveyData.aadhaar_No
                              : cropSurveyData.aadhaarNo}
                          </p>
                        </div>

                        <div className="col-md-3">
                          <h6>Mobile No.</h6>
                          <p>
                            {sessionStorage.getItem("schemeCodeModel") === "10"
                              ? cropSurveyData.mobile_No
                              : cropSurveyData.mobileNo}
                          </p>
                        </div>
                        {sessionStorage.getItem("schemeCodeModel") === "10" || sessionStorage.getItem("schemeCodeModel") === "11"  ? (
                          <div className="col-md-3">
                            <h6>Address</h6>
                            <p>{cropSurveyData.address}</p>
                          </div>
                        ) : (
                          ""
                        )}
                        <div className="col-md-3">
                          <h6> {cropSurveyData.gender === "M"
                            ? "Gender"
                            : cropSurveyData.gender === "F"
                              ? "Gender"
                              : cropSurveyData.gender === "T"
                                ? "Gender"
                                : ""}</h6>
                          <p>
                            {cropSurveyData.gender === "M"
                              ? "Male"
                              : cropSurveyData.gender === "F"
                                ? "Female"
                                : cropSurveyData.gender === "T"
                                  ? "Transgender"
                                  : ""}
                          </p>
                        </div>

                        {
                          sessionStorage.getItem("schemeCodeModel") === "7" ||
                          sessionStorage.getItem("schemeCodeModel") === "10" ? (
                          ""
                        ) : (
                          <div className="col-md-3">
                            <h6>Caste Category</h6>
                            <p>{cropSurveyData.casteCatName}{cropSurveyData.casteCategory}</p>
                          </div>

                          
                        )}

                        {
                          sessionStorage.getItem("schemeCodeModel") === "7" ||
                          sessionStorage.getItem("schemeCodeModel") === "8" ||
                          
                          sessionStorage.getItem("schemeCodeModel") === "10" ||
                          sessionStorage.getItem("schemeCodeModel") === "11" ? (
                          ""
                        ) : (
                          <>
                            <div className="col-md-3">
                              <h6>Activity Type</h6>
                              <p>{cropSurveyData.activityType}</p>
                            </div>
                            <div className="col-md-3">
                              <h6>Activity SubType</h6>
                              <p>{cropSurveyData.activitySubType}</p>
                            </div>{" "}
                          </>
                        )}

                        {sessionStorage.getItem("schemeCodeModel") === "8" || sessionStorage.getItem("schemeCodeModel") === "10" ? (
                          ""
                        ) : (
                          <div className="col-md-3">
                            <h6>Farmer Type</h6>
                            <p>
                              {cropSurveyData.farmerType === 1
                                ? "Small and Marginal"
                                : "Other"}
                            </p>
                          </div>
                        )}

                        {sessionStorage.getItem("schemeCodeModel") === "10" && cropSurveyData.componentId != 14 ? (
                          <div className="col-md-3">
                            <h6>Beneficiary Type</h6>
                            <p>
                              {cropSurveyData.beneficiaryTypeName}
                            </p>
                          </div>
                        ) : ""}
                        {sessionStorage.getItem("schemeCodeModel") === "10" ? (
                          <div className="col-md-3">
                            <h6>{cropSurveyData.componentId === 14 ? "Name of Promoter" : "Beneficiary Name"}</h6>
                            <p>
                              {cropSurveyData.beneficiaryName}
                            </p>
                          </div>
                        ) : ""}
                        {sessionStorage.getItem("schemeCodeModel") === "10" && cropSurveyData.componentId != 14 ? (
                          <div className="col-md-3">
                            <h6>Beneficiary Reg No/ID</h6>
                            <p>
                              {cropSurveyData.beneficiary_Reg_No}
                            </p>
                          </div>
                        ) : ""}
                      </div>
                      </div>

                      <div className="row cropview">
                        <h5 className="formgrouping">Place Details</h5>
                        <div className="row surveydetailsbg"> <div className="col-md-3">
                          <h6>State</h6>
                          <p>{cropSurveyData.stateName}</p>
                        </div>
                        <div className="col-md-3">
                          <h6>District</h6>
                          <p>{cropSurveyData.districtName}</p>
                        </div>
                       <div className="col-md-3">
  {["20", "8", "9", "15", "46"].includes(
  sessionStorage.getItem("schemeCodeModel")
) ? (
  <>
    <h6>Block</h6>
    <p>{cropSurveyData.blockName}</p>
  </>
) : (
  <>
    <h6>Sub District</h6>
    <p>{cropSurveyData.subDistrictName}</p>
  </>
)}
</div>
                        <div className="col-md-3">
                          <h6>Village</h6>
                          <p>{cropSurveyData.villageName}</p>
                        </div>
                      </div>
              </div>

                      {sessionStorage.getItem("schemeCodeModel") === "7" ||
                       
                        sessionStorage.getItem("schemeCodeModel") === "6" ||
                        sessionStorage.getItem("schemeCodeModel") === "8" ||
                        
                        sessionStorage.getItem("schemeCodeModel") === "10"
                        ? (
                          <></>
                        ) : (
                          cropSurveyData && cropSurveyData.farmerCropDetailsExtsList && cropSurveyData.farmerCropDetailsExtsList.length > 0 ? (
                          <div className="row cropview">
                            <h5 className="formgrouping">Crop Details</h5>
                            <table
                              className="table table-bordered datatable"
                              style={{ marginTop: "35px" }}
                            >
                              {" "}
                              <thead style={{ backgroundColor: "lightgrey" }}>
                                {" "}
                                <tr>
                                  <th scope="col">Crop Name</th>
                                  <th scope="col">Crop Group</th>


                                  {sessionStorage.getItem("schemeCodeModel") ===
                                    "11" ? (
                                    ""
                                  ) : (
                                    <th scope="col">Crop Variety</th>
                                  )}
                                  {sessionStorage.getItem("schemeCodeModel") ===
                                    "6" || sessionStorage.getItem("schemeCodeModel") ===
                                    "11" || sessionStorage.getItem("schemeCodeModel") ===
                                    "17" ? (
                                    ""
                                  ) : (
                                    <th scope="col">Crop Stage</th>
                                  )}
                                  <th scope="col">Season </th>
                                  <th scope="col">Financial Year</th>
                                  {sessionStorage.getItem("schemeCodeModel") ===
                                    "11" ? (
                                    ""
                                  ) : (
                                    <th scope="col">Varietal Characteristics</th>
                                  )}

                                  <th scope="col">Created Date</th>{" "}
                                </tr>
                              </thead>
                              <tbody>
                                {cropSurveyData.farmerCropDetailsExtsList &&
                                  cropSurveyData.farmerCropDetailsExtsList.map(
                                    (item, index) => {
                                      return (
                                        <tr key={index}>
                                          <td>{item.cropName}</td>
                                          <td>{item.cropGroupName}</td>
                                          {sessionStorage.getItem("schemeCodeModel") ===
                                            "11" ? (
                                            ""
                                          ) : (
                                            <td>{item.cropVarietyName}</td>
                                          )}

                                          {sessionStorage.getItem(
                                            "schemeCodeModel"
                                          ) === "6" || sessionStorage.getItem(
                                            "schemeCodeModel"
                                          ) === "11" || sessionStorage.getItem(
                                            "schemeCodeModel"
                                          ) === "17" ? (
                                            ""
                                          ) : (
                                            <td>
                                              {
                                                cropSurveyData?.farmerCropStageList?.[0]
                                                  ?.cropStageName || 'N/A'
                                              }
                                            </td>
                                          )}
                                          <td>{item.seasonName}</td>
                                          <td>{item.finYear}</td>
                                          {sessionStorage.getItem("schemeCodeModel") ===
                                            "11" ? (
                                            ""
                                          ) : (
                                            <td>{item.varietalCharacteristics}</td>
                                          )}<td>{item.createdOn.split("T")[0]}</td>
                                        </tr>
                                      );
                                    }
                                  )}
                              </tbody>
                            </table>
                          </div>
                          ) : null
                        )}
                      {sessionStorage.getItem("schemeCodeModel") === "11" || sessionStorage.getItem("schemeCodeModel") === "8" || sessionStorage.getItem("schemeCodeModel") === "1" ? (
                        <><div className="row cropview">
                          <h5 className="formgrouping">Image Details</h5>
                          {!cropSurveyData.farmerCropSurveyImageList || cropSurveyData.farmerCropSurveyImageList.length ===
                            0 ? (
                            <></>
                          ) : (
                            cropSurveyData.farmerCropSurveyImageList.map(
                              (item, index) => {
                                return (
                                  <>
                                    <div className="col-md-2">
                                      <img
                                        src={
                                          process.env.NODE_ENV === "development"
                                            ? process.env.REACT_APP_DEV_MODE +
                                            "/api/common/GetAttachbyURL?imageURL=" +
                                            item.attPath
                                            : process.env.REACT_APP_PRO_MODE +
                                            "/api/common/GetAttachbyURL?imageURL=" +
                                            item.attPath
                                        }
                                        alt="farmer Image"
                                        data-bs-toggle="modal"
                                        data-bs-target="#staticBackdrop"
                                        className="img-fluid imgdetials"
                                        id="imgFarmer"
                                        onClick={() => handleActiveClick(index)}
                                      />
                                    </div>
                                    <div className="col-md-4">
                                    <div className="row imgdetialsbg">
                                      <div className="col-md-6">
                                        <h6>Latitude</h6>
                                        <p>{item.surveyorLat}</p>
                                      </div>
                                      <div className="col-md-6">
                                        <h6>Longitude</h6>
                                        <p>{item.surveyorLong}</p>
                                      </div>
                                    </div></div>
                                  </>
                                );
                              }
                            )
                          )}
                        </div></>) : (<></>)}






                      {sessionStorage.getItem("schemeCodeModel") === "91" ? (
                        <>
                          <div className="row cropview">
                            <h5 className="formgrouping">Crop Details</h5>
                            <table
                              className="table table-bordered datatable"
                              style={{ marginTop: "35px" }}
                            >
                              {" "}
                              <thead style={{ backgroundColor: "lightgrey" }}>
                                {" "}
                                <tr>
                                  <th scope="col">S.No.</th>
                                  <th scope="col">Crop Group</th>
                                  <th scope="col">Crop Name</th>
                                  <th scope="col">Crop Yield</th>
                                </tr>
                              </thead>
                              <tbody>
                                {cropSurveyData.farmerCropDetailsExtsList &&
                                  cropName.map((item, index) => {
                                    return (
                                      <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{cropGroupName[index]}</td>
                                        <td>{item}</td>
                                        <td>{cropYield[index]}</td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          </div>



                          <div className="row cropview">
                            <h5 className="formgrouping">Image Details</h5>
                            {!cropSurveyData.farmerCropSurveyImageList || cropSurveyData.farmerCropSurveyImageList.length ===
                              0 ? (
                              <></>
                            ) : (
                              cropSurveyData.farmerCropSurveyImageList.map(
                                (item, index) => {
                                  return (
                                    <>
                                      <div className="col-md-3">
                                        <img
                                          src={
                                            process.env.NODE_ENV === "development"
                                              ? process.env.REACT_APP_DEV_MODE +
                                              "/api/common/GetAttachbyURL?imageURL=" +
                                              item.attPath
                                              : process.env.REACT_APP_PRO_MODE +
                                              "/api/common/GetAttachbyURL?imageURL=" +
                                              item.attPath
                                          }
                                          alt="farmer Image"
                                          data-bs-toggle="modal"
                                          data-bs-target="#staticBackdrop"
                                          className="img-fluid h-50 w-100"
                                          id="imgFarmer"
                                          onClick={() => handleActiveClick(index)}
                                        />
                                      </div>
                                      <div className="col-md-3">
                                        <div>
                                          <h6>Latitude</h6>
                                          <p>{item.surveyorLat}</p>
                                        </div>
                                        <div>
                                          <h6>Longitude</h6>
                                          <p>{item.surveyorLong}</p>
                                        </div>
                                      </div>
                                    </>
                                  );
                                }
                              )
                            )}
                          </div>  </>) : (
                        ""
                      )}

                      <div className="row cropview"></div>
                    </div>
                  )}

                </div>

              </div>

            </div>
            {/* <div className='image_viewer' id="image_viewer"></div> */}
          </section>
        </main>
      )}
      
      <AdminFooterNew />

      <div id="mpopupBox" className="modal">
        <div className="modal-content">
          <div className="modal-header">
            <h2>View Details</h2>
            <button type="button" className="btn-close" onClick={removed}>
              X
            </button>
          </div>
          <div className="madal-body" id="modal-content"></div>
          <div className="modal-footer"></div>
        </div>
      </div>

      {cropSurveyData && console.log("!!cropSurveyData", cropSurveyData)}
      {sessionStorage.getItem("schemeCodeModel") !== "1" && 
       sessionStorage.getItem("schemeCodeModel") !== "15" &&
        
       cropSurveyData && 
       cropSurveyData.farmerCropSurveyImageList && 
       cropSurveyData.farmerCropSurveyImageList.length > 0 && (
        <div
          className="modal fade "
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">
                  Image{" "}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  X
                </button>
              </div>
              <div className="modal-body" id="modalBody"></div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default React.memo(FarmerDetailView);
